import React from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@mui/material';

export default function DataTable({ columns, rows }) {
    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow sx={{ bgcolor: 'grey.100' }}>
                        {columns.map(col => (
                            <TableCell key={col.key}><strong>{col.label}</strong></TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, i) => (
                        <TableRow key={row.key ?? i}>
                            {columns.map(col => (
                                <TableCell key={col.key}>{col.render ? col.render(row[col.key]) : row[col.key]}</TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
